import {merge as observableMerge , Observable , BehaviorSubject , Subscription} from 'rxjs';

import {map} from 'rxjs/operators';
import {
  Component , ElementRef , EventEmitter , Inject , Input , OnChanges , OnInit , Output , SimpleChanges , ViewChild ,
  ViewChildren , OnDestroy
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import {DataSource , SelectionModel} from '@angular/cdk/collections';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import jsPDF from 'jspdf';
import {NgxSpinnerService} from 'ngx-spinner';
import {Router} from '@angular/router';
import * as fileSaver from 'file-saver';
import {TranslateService} from '@ngx-translate/core';
import moment from 'moment';
import {ToastrService} from 'ngx-toastr';
import ExcelJS from 'exceljs';
import {FusePerfectScrollbarDirective} from '../../../../../core/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';
import {EventService} from '../../../../../core/services/event.service';
import {FuseConfigService} from '../../../../../core/services/config.service';
import {FuseDeleteDialogComponent} from '../../../../../core/components/delete-dialog/delete-dialog.component';
import {SubEventParticipantModalComponent} from '../../../events/sub-event-participant-modal/sub-event-participant.modal';
import {AddCreditsComponent} from '../../../events/add-credits/add-credits.component';
import {FrontUserService} from '../../../../../core/services/frontUsers.service';
import {EditGuestData} from '../../../events/edit-guest-data/editGuestData';
import {FuseUtils} from '../../../../../core/fuseUtils';
import {MaterialModule} from '../../../../../core/modules/material.module';
import {SharedModule} from '../../../../../core/modules/shared.module';
import {fuseAnimations} from '../../../../../core/animations';
import {AddSkillComponent} from '../add-skill/add-skill.component';

@Component({
    selector: 'participant-component',
    templateUrl: './participant.html',
    styleUrls: ['./participant.scss'],
  animations: fuseAnimations,
  standalone: true,
  imports: [MaterialModule, SharedModule]
})

export class ParticipantComponentNew implements OnChanges , OnDestroy {

  @Input() participants;
  @Input() type;
  @Input() isEdit;
  @Input() blockEditCredit = false;
  @Input() eventData;
  @Input() subEvents;
  @Output() count = new EventEmitter();
  @Output() update = new EventEmitter();
  @Output() updateSubEvents = new EventEmitter();
  public subscription = new Subscription();
  backGround = 'data:image/png;base64,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';
  logoImg = 'data:image/png;base64,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';
  displayedColumns = [ 'name' , 'organization' , 'targetGroup', 'createdAt' ];
  public filterData: any = {};
  users: FilesDataSource | null;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild('filter', {static: true}) filter: ElementRef;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChildren(FusePerfectScrollbarDirective) scroll;
  @ViewChild('pdfContent') pdfContent: ElementRef;
  eventID;
  eventName;
  keys = [];
  selectedIndex = 0;
  selection = new SelectionModel<any>(true , []);
  eCall = false;
  whatsapp = false;
  checkedUsers = [];
  organizationId;
  usersForCSV = [];
  lang;
  isReadOnly = false;
  selectedVal = 'hide';
  skillExist = false;

  constructor (public dialog: MatDialog , public eventService: EventService ,
               private spinner: NgxSpinnerService, private router: Router,
               private fuseConfig: FuseConfigService, public tr: TranslateService,
               private toastr: ToastrService) {
    this.fuseConfig.eCall.subscribe(res => {
      if (res && res !== 'null') {
        this.eCall = true;
      }
    });
    this.fuseConfig.whatsapp.subscribe(res => {
      if (res && res !== 'null') {
        this.whatsapp = true;
      }
    });
    this.fuseConfig.organizationId.subscribe((res) => {
      if (res) {
        this.organizationId = parseInt(res, 10);
      }
    });
    this.fuseConfig.role.subscribe(res => {
      this.isReadOnly = false;
      if (res && res === 'readOnly') {
        this.isReadOnly = true;
      }
    });
    this.lang = this.tr.currentLang;
  }

  ngOnChanges (changes: SimpleChanges) {
    if (this.participants) {
      if (this.type === 'participants') {
        if (!this.isEdit) {
          this.displayedColumns = ['name' , 'organization' , 'targetGroup' , 'reward', 'createdAt', 'deleteFromParticipant'  ];
        } else {
          this.displayedColumns = [ 'select' , 'name' , 'organization' , 'targetGroup' , 'reward', 'createdAt', 'deleteFromParticipant' ];
        }
        if (this.isReadOnly) {
          this.displayedColumns = ['name' , 'organization' , 'targetGroup' , 'reward', 'createdAt'];
        }
      } else {
        if (!this.isEdit) {
          this.displayedColumns = [  'name' , 'organization' , 'targetGroup', 'createdAt', 'moveToParticipant', 'deleteFromParticipant'  ];
        } else {
          this.displayedColumns = [  'name' , 'organization' , 'targetGroup' , 'createdAt', 'moveToParticipant' , 'deleteFromParticipant'];
        }
        if (this.isReadOnly) {
          this.displayedColumns = ['name' , 'organization' , 'targetGroup' , 'createdAt'];
        }
      }
      this.keys = Object.keys(this.participants);
      this.eventID = this.participants[ this.keys[ this.selectedIndex ] ][ 0 ].eventId;
      this.eventName = this.participants[ this.keys[ this.selectedIndex ] ][ 0 ].event ?
        this.participants[ this.keys[ this.selectedIndex ] ][ 0 ].event.title : '';
      this.count.emit(this.participants[ this.keys[ this.selectedIndex ] ].length);
      const userData = {
        users: this.participants[ this.keys[ this.selectedIndex ] ] ,
        onEventChanged: new BehaviorSubject({})
      };
      this.users = new FilesDataSource(userData , this.paginator , this.sort);
      this.usersForCSV = this.participants[ this.keys[ this.selectedIndex ] ];
      for (let p = 0; p < this.participants[ this.keys[ this.selectedIndex ] ].length; p++) {
        if (this.participants[ this.keys[ this.selectedIndex ] ][p].data && !this.participants[ this.keys[ this.selectedIndex ] ][p].frontUserId) {
          let data = JSON.parse(this.participants[ this.keys[ this.selectedIndex ] ][p].data);
          this.participants[ this.keys[ this.selectedIndex ] ][p].parsedData = data;
        }
      }
      // console.log( this.participants[ this.keys[ this.selectedIndex ] ]);
    }
    if (this.eventData) {
      this.skillExist = this.eventData.skills && this.eventData.skills.length > 0;
    }
  }

  get isAllSelected () {
    const numSelected = this.selection.selected.length;
    const numRows = this.users.filteredData.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle () {
    this.isAllSelected ?
      this.selection.clear() :
      this.users.filteredData.forEach(row => this.selection.select(row));
    this.checkedUsers = this.selection.selected;
  }

  checkUser (user , event) {
    if (event.checked) {
      this.checkedUsers.push(user);
    } else {
      let index = this.checkedUsers.findIndex(x => +x.id === +user.id);
      if (index !== -1) {
        this.checkedUsers.splice(index , 1);
      }
    }
  }

  moveToParticipant (event , user) {
    event.stopPropagation();
    user.isOnEvent = true;
    user.isGuest = !user.frontUserId;
    this.eventService.moveFromWaitingLisr(user).subscribe((res) => {
      if (res) {
        this.update.emit(true);
      }
    });
  }

  deleteFromParticipant (event , user) {
    event.stopPropagation();
    if (!user.credits) {
      const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
        width: '300px' , height: 'auto',
        data: {title: 'Delete' , message: 'deleteConfirm'}
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          let isFront = user.frontUserId ? true : false;
          let id = user.frontUserId ? user.id : user.parId;
          this.eventService.deleteFromParticipant(id, isFront).subscribe((res) => {
            if (res) {
              if (isFront) {
                this.participants[this.keys[this.selectedIndex]].splice(this.participants[this.keys[this.selectedIndex]].findIndex(x => +x.id === +id), 1);
              } else {
                this.participants[this.keys[this.selectedIndex]].splice(this.participants[this.keys[this.selectedIndex]].findIndex(x => +x.parId === +id), 1);
              }
              const userData = {
                users: this.participants[ this.keys[ this.selectedIndex ] ] ,
                onEventChanged: new BehaviorSubject({})
              };
              this.users = new FilesDataSource(userData , this.paginator , this.sort);
              this.update.emit(true);
            }
          });
        }
      });
    } else {
      const dialogRef = this.dialog.open(FuseDeleteDialogComponent ,
        { panelClass: 'unsave-form-dialog',
        width: '300px' , height: 'auto',
        data: {title: 'Delete_error' , message: 'delete_perticipant_error'}
      });
      // dialogRef.afterClosed().subscribe(result => {
      //   if (result) {
      //     let isFront = user.frontUserId ? true : false;
      //     let id = user.frontUserId ? user.id : user.parId;
      //     this.eventService.deleteFromParticipant(id, isFront).subscribe((res) => {
      //       if (res) {
      //         this.update.emit(true);
      //       }
      //     });
      //   }
      // });
    }
  }

  openSubEvents() {
    const dialogRef = this.dialog.open(SubEventParticipantModalComponent , {
      panelClass: 'sub-event-participant-modal' , width: '90%', maxHeight: '90vh',
      data: {participants: this.participants, subEvents: this.subEvents, eventId: this.eventID,
      eventData: this.eventData},
    });
    dialogRef.afterClosed().subscribe(res => {
      this.updateSubEvents.emit();
    });
  }

  openAddCredits () {
    const dialogRef = this.dialog.open(AddCreditsComponent , {
      panelClass: 'unsave-form-dialog' , height: 'auto', width: '500px',
      data: this.checkedUsers
    });
    dialogRef.afterClosed().subscribe(res => {
      this.selection.clear();
      this.checkedUsers = [];
      this.update.emit(true);
    });
  }

  openAddSkills () {
    const dialogRef = this.dialog.open(AddSkillComponent , {
      panelClass: 'unsave-form-dialog' , height: 'auto', width: '500px',
      data: {users: this.checkedUsers, eventId: this.eventID, skillIds: this.eventData.skills,
      skills: this.eventData.skillsData}
    });
    dialogRef.afterClosed().subscribe(res => {
      this.selection.clear();
      this.checkedUsers = [];
      this.update.emit(true);
    });
  }

  communicationAction(event) {
    if (event.value === 'emailList' || event.value === 'emailListWithParents') {
      this.selectedVal = event.value;
      let emails = [];
      for (let i = 0; i < this.checkedUsers.length; i++) {
        if (this.checkedUsers[i].frontUser && this.checkedUsers[i].frontUser.email) {
          emails.push(this.checkedUsers[i].frontUser.email);
        }
        if (this.checkedUsers[i].email) {
          emails.push(this.checkedUsers[i].email);
        }
        if (event.value === 'emailListWithParents') {
          if (this.checkedUsers[i].mother && this.checkedUsers[i].mother.email) {
            emails.push(this.checkedUsers[i].mother.email);
          }
          if (this.checkedUsers[i].father && this.checkedUsers[i].father.email) {
            emails.push(this.checkedUsers[i].father.email);
          }
          if (this.checkedUsers[i].parsedData && this.checkedUsers[i].parsedData.mother_email) {
            emails.push(this.checkedUsers[i].parsedData.mother_email);
          }
          if (this.checkedUsers[i].parsedData && this.checkedUsers[i].parsedData.father_email) {
            emails.push(this.checkedUsers[i].parsedData.father_email);
          }
          if (this.checkedUsers[i].representatives) {
            let repEmails = this.checkedUsers[i].representatives.map(user => user.email);
            repEmails = repEmails.filter(el => !!el);
            emails = emails.concat(repEmails);
          }
        }
      }
      if (!emails.length) {
        this.toastr.error('Ausgewählte User haben keine E-Mail' , 'Error!');
        setTimeout(() => {
          this.selectedVal = 'hide';
        }, 500);
        return;
      }
      const to = emails[0];
      emails.shift();
      const cc = '';
      const bcc = emails.join(',');
      const subject = 'Betreff der E-Mail';
      const body = 'Inhalt der E-Mail...';

      this.generateEmltlFile(to, cc, bcc, subject, body);
      setTimeout(() => {
        this.selectedVal = 'hide';
      }, 500);
      return;
    }
    if (event.value === 'mail' || event.value === 'mailWithParent') {
      let emails = [];
      for (let i = 0; i < this.checkedUsers.length; i++ ) {
        if (this.checkedUsers[i].frontUser && this.checkedUsers[i].frontUser.email) {
          emails.push(this.checkedUsers[i].frontUser.email);
        }
        if (this.checkedUsers[i].email) {
          emails.push(this.checkedUsers[i].email);
        }
        if (event.value === 'mailWithParent') {
          if (this.checkedUsers[i].mother && this.checkedUsers[i].mother.email) {
            emails.push(this.checkedUsers[i].mother.email);
          }
          if (this.checkedUsers[i].father && this.checkedUsers[i].father.email) {
            emails.push(this.checkedUsers[i].father.email);
          }
          if (this.checkedUsers[i].parsedData && this.checkedUsers[i].parsedData.mother_email) {
            emails.push(this.checkedUsers[i].parsedData.mother_email);
          }
          if (this.checkedUsers[i].parsedData && this.checkedUsers[i].parsedData.father_email) {
            emails.push(this.checkedUsers[i].parsedData.father_email);
          }
          if (this.checkedUsers[i].representatives) {
            let repEmails = this.checkedUsers[i].representatives.map(user => user.email);
            repEmails = repEmails.filter(el => !!el);
            emails = emails.concat(repEmails);
          }
        }
      }
      let uniqueSet = new Set(emails);
      emails = [...uniqueSet];
      this.router.navigate(['/pages/communications'], {queryParams: {
          type: 'mail',
          subtype: 'participant',
          ids: emails.toString()
        }});
    } else {
      let ids = [];
      let guestIds = [];
      for (let i = 0; i < this.checkedUsers.length; i++ ) {
        if (this.checkedUsers[i].frontUserId) {
          ids.push(this.checkedUsers[i].frontUserId);
        }
        if (this.checkedUsers[i].guestUserId) {
          guestIds.push(this.checkedUsers[i].guestUserId);
        }
      }
      this.router.navigate(['/pages/communications'], {queryParams: {
        type: event.value,
        ids: ids.toString(),
          guestIds: guestIds.toString()
      }});
    }
  }

  generateEmltlFile(to, cc, bcc, subject, body) {
    const emlContent = `To: ${to}\r\nCc: ${cc || ''}\r\nBcc: ${bcc || ''}\r\nSubject: ${subject}\r\nX-Unsent: 1\r\nContent-Type: text/html\r\n\r\n<html><body>${body}</body></html>`;
    const blob = new Blob([emlContent], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'email.eml';
    a.click();

    URL.revokeObjectURL(url);
  }

  // generateEmlFile(to, cc, bcc, subject, body) {
  //   const emlContent = `To: ${to}\r\nCc: ${cc || ''}\r\nBcc: ${bcc || ''}\r\nSubject: ${subject}\r\n\r\n${body}`;
  //
  //   const blob = new Blob([emlContent], { type: 'message/rfc822' });
  //   const url = URL.createObjectURL(blob);
  //
  //   const a = document.createElement('a');
  //   a.href = url;
  //   a.download = 'email.eml';
  //   a.click();
  //
  //   URL.revokeObjectURL(url);
  // }


  print (): void {
    let printContents , popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('' , '_blank' , 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <style>
   body {
  font-family: "Open Sans", sans-serif;
  line-height: 1.25;
}
table {
  border: 1px solid #ccc;
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
}
table caption {
  font-size: 1.5em;
  margin: .5em 0 .75em;
}
table tr {
  border: 1px solid #ddd;
  padding: .35em;
}
table tr:nth-child(even) {
  background: #f8f8f8;
}
table th,
table td {
  padding: .625em;
  text-align: left;
  font-size: 0.75em;
}
table th {
  background: #999;
  color: #fff;
  font-size: .85em;
  letter-spacing: .1em;
  text-transform: uppercase;
}
table td {
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
}

          </style>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }

  changeIndex (i) {
    this.selectedIndex = i;
    const userData = {
      users: this.participants[ this.keys[ this.selectedIndex ] ] ,
      onEventChanged: new BehaviorSubject({})
    };
    this.count.emit(this.participants[ this.keys[ this.selectedIndex ] ].length);
    this.users = new FilesDataSource(userData , this.paginator , this.sort);
    this.usersForCSV = this.participants[ this.keys[ this.selectedIndex ] ];
  }

  downloadPDF (type) {
    this.spinner.show();
    this.subscription.add(this.eventService.getQrcode(this.eventID).subscribe((res: any) => {
      const doc = new jsPDF('p', 'mm');
      for (let i = 0; i < res.length; i++) {
        if (res[ i ].frontUser) {
          let splitTitle = doc.splitTextToSize(this.eventName, 140);
          doc.addImage(this.logoImg , 'JPEG' , 20 , 10, 80, 20);
          doc.setFont('normal');
          doc.setFontSize(20);
          doc.text(splitTitle, 20 , 60);
          let rowSize = splitTitle.length * 11;

          doc.setFontSize(29);
          doc.setFont('bold');
          doc.text(res[ i ].frontUser.lastName + ' ' + res[ i ].frontUser.firstName, 20 , 60 + rowSize);

          doc.setFontSize(50);
          doc.setFont('bold');
          doc.addImage(this.backGround , 'JPEG' , 20 , 67 + rowSize, 110, 30);
          doc.setTextColor('white');
          doc.text(res[ i ].code, 30 , 90 + rowSize);


          doc.setTextColor('black');
          doc.addImage(res[ i ].img , 'JPEG' , 120 , 200 , 80 , 80);
          doc.setFontSize(12);
          doc.setFont('normal');
          doc.text('QR-Code nach Gebrauch sofort vernichten! \nEr darf nicht in fremde Hände kommen.', 20 , 195 + rowSize);

          doc.setFontSize(16);
          doc.setFont('bold');
          doc.text('www.pfefferstern.ch', 20 , 215 + rowSize);
          if (i !== res.length - 1) {
            doc.addPage('a4');
          }
        }
      }
      if (type === 'download') {
        doc.save('Code_' + this.eventName + '_' + '.pdf');
      }
      this.spinner.hide();
    }));
  }

  openDialog (user): void {
    if (this.isEdit) {
      const dialogRef = this.dialog.open(DialogOverview , {
        width: 'auto' ,
        data: {user: user, event: this.eventData}
      });
      dialogRef.afterClosed().subscribe(result => {
        if (DialogOverview.dataWasChanged) {
          this.update.emit(true);
        }
      });
    } else {
      if (user.frontUser.organizationId === this.organizationId) {
        const dialogRef = this.dialog.open(DialogOverview , {
          width: 'auto' ,
          data: {user: user, event: this.eventData}
        });
        dialogRef.afterClosed().subscribe(result => {
          if (DialogOverview.dataWasChanged) {
            this.update.emit(true);
          }
        });
      }
    }

  }

  downloadCSV() {
    if (!this.eventData.additionalForm) {
      let _csvArray = this.usersForCSV.map((el) => {
        let user = {};
        if (el.frontUserId) {
          user = {
            Vorname: el.frontUser.firstName,
            Nachname: el.frontUser.lastName,
            Organisation: el.frontUser.organization.name,
            Zielgruppe: (el.frontUser.targetGroup && el.frontUser.targetGroup.ageMask) ? el.frontUser.targetGroup.ageMask : '',
            Telefon: el.frontUser.phone,
            'Mobile-Nr.' : el.frontUser.mobile,
            'E-Mail': el.frontUser.email,
            Geschlecht: el.frontUser.gender,
            Registrierungsdatum: moment(el.createdAt).format('DD.MM.YYYY '),
            Registrierungszeit: moment(el.createdAt).format('HH:mm'),
            Strasse: el.frontUser.street,
            Hausnummer: el.frontUser.number,
            PLZ: el.frontUser.postcode,
            Ort: el.frontUser.cityLocation,
            Gruppenanmeldung: '',
            'Name_der_Organisation': '',
            'Anzahl_der_Personen': '',
            'M/Vorname': el.mother ? el.mother.firstName : '',
            'M/Nachname': el.mother ? el.mother.lastName : '',
            'M/Strasse': el.mother ? el.mother.street : '',
            'M/Hausnummer': el.mother ? el.mother.number : '',
            'M/PLZ': el.mother ? el.mother.postcode : '',
            'M/Ort': el.mother ? el.mother.cityLocation : '',
            'M/Telefon': el.mother ? el.mother.phone : '',
            'M/Mobile-Nr.': el.mother ? el.mother.mobile : '',
            'M/E-Mail': el.mother ? el.mother.email : '',
            'V/Vorname': el.father ? el.father.firstName : '',
            'V/Nachname': el.father ? el.father.lastName : '',
            'V/Strasse': el.father ? el.father.street : '',
            'V/Hausnummer': el.father ? el.father.number : '',
            'V/PLZ': el.father ? el.father.postcode : '',
            'V/Ort': el.father ? el.father.cityLocation : '',
            'V/Telefon': el.father ? el.father.phone : '',
            'V/Mobile-Nr.': el.father ? el.father.mobile : '',
            'V/E-Mail': el.father ? el.father.email : ''
          };
        } else {
          let yes = this.tr.instant('yes');
          let no = this.tr.instant('no');
          user = {
            Vorname: el.firstName,
            Nachname: el.lastName,
            Organisation: '',
            Zielgruppe: '',
            Telefon: el.phone,
            'Mobile-Nr.' : el.mobile,
            'E-Mail': el.email,
            Geschlecht: el.gender,
            Registrierungsdatum: moment(el.createdAt).format('DD.MM.YYYY '),
            Registrierungszeit: moment(el.createdAt).format('HH:mm'),
            Strasse: el.street,
            Hausnummer: el.number,
            PLZ: el.postcode,
            Ort: el.cityName,
            Gruppenanmeldung: el.groupRegistration ? yes : no,
            'Name_der_Organisation': el.nameOfOrganization,
            'Anzahl_der_Personen': el.numberOfPeople,
            'M/Vorname': '',
            'M/Nachname': '',
            'M/Strasse': '',
            'M/Hausnummer': '',
            'M/PLZ': '',
            'M/Ort': '',
            'M/Telefon': '',
            'M/Mobile-Nr.': '',
            'M/E-Mail':  '',
            'V/Vorname': '',
            'V/Nachname': '',
            'V/Strasse': '',
            'V/Hausnummer': '',
            'V/PLZ': '',
            'V/Ort':  '',
            'V/Telefon': '',
            'V/Mobile-Nr.': '',
            'V/E-Mail': ''
          };
        }

        return user;
      });
      const replacer = (key, value) => value === null ? '' : value; // specify how you want to handle null values here
      //const header = Object.keys(_csvArray[0]);


         let allKeys = new Set<string>();
      _csvArray.forEach(user => {
        Object.keys(user).forEach(key => allKeys.add(key));
      });
      const header: string[] = Array.from(allKeys);

      
      let csv = _csvArray.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
      csv.unshift(header.join(','));
      let csvArray = csv.join('\r\n');
      let blob = new Blob([csvArray], {type: 'text/csv;charset=windows-1252;' });
      fileSaver.saveAs(blob, 'myFile.csv');
    } else {
      this.getTableInfoCSV();
    }
  }

  getTableInfoCSV() {
    this.eventService.getTableInfoById(this.eventData.guestData).subscribe((res: any) => {
      let allGuestTitles: any = {};
      if (res && res.length) {
        res.forEach(el => {
          allGuestTitles[el.name] = '';
        });
      }
      if (allGuestTitles && allGuestTitles.hasOwnProperty('passport')) {
        allGuestTitles = this.addToObject(allGuestTitles, 'expiry_date', '', 1);
      }
      let _csvArray = this.usersForCSV.map((el) => {
        let user: any = {};
        if (el.frontUserId) {
          user = {
            Vorname: el.frontUser.firstName,
            Nachname: el.frontUser.lastName,
            Organisation: el.frontUser.organization.name,
            'Name der Kirchgemeinde': '',
            Zielgruppe: (el.frontUser.targetGroup && el.frontUser.targetGroup.ageMask) ? el.frontUser.targetGroup.ageMask : '',
            Telefon: el.frontUser.phone,
            'Mobile-Nr.' : el.frontUser.mobile,
            'E-Mail': el.frontUser.email,
            Geschlecht: el.frontUser.gender,
            Registrierungsdatum: moment(el.createdAt).format('DD.MM.YYYY '),
            Registrierungszeit: moment(el.createdAt).format('HH:mm'),
            Strasse: el.frontUser.street,
            Hausnummer: el.frontUser.number,
            PLZ: el.frontUser.postcode,
            Ort: el.frontUser.cityLocation,
            Gruppenanmeldung: '',
            'Name_der_Organisation': '',
            'Anzahl_der_Personen': '',
            'M/Vorname': el.mother ? el.mother.firstName : '',
            'M/Nachname': el.mother ? el.mother.lastName : '',
            'M/Strasse': el.mother ? el.mother.street : '',
            'M/Hausnummer': el.mother ? el.mother.number : '',
            'M/PLZ': el.mother ? el.mother.postcode : '',
            'M/Ort': el.mother ? el.mother.cityLocation : '',
            'M/Telefon': el.mother ? el.mother.phone : '',
            'M/Mobile-Nr.': el.mother ? el.mother.mobile : '',
            'M/E-Mail': el.mother ? el.mother.email : '',
            'V/Vorname': el.father ? el.father.firstName : '',
            'V/Nachname': el.father ? el.father.lastName : '',
            'V/Strasse': el.father ? el.father.street : '',
            'V/Hausnummer': el.father ? el.father.number : '',
            'V/PLZ': el.father ? el.father.postcode : '',
            'V/Ort': el.father ? el.father.cityLocation : '',
            'V/Telefon': el.father ? el.father.phone : '',
            'V/Mobile-Nr.': el.father ? el.father.mobile : '',
            'V/E-Mail': el.father ? el.father.email : ''
          };
          user = Object.assign(user, allGuestTitles);
          user.individual = '';
          if (el.data && el.data.data) {
            let data = JSON.parse(el.data.data);
            let _keys = Object.keys(data);
            _keys.forEach(key => {
              if (data[key] === true || data[key] === 'true') {
                let translate = this.tr.instant('yes');
                data[key] = translate;
              } else if (data[key] === false || data[key] === 'false') {
                let translate = this.tr.instant('no');
                data[key] = translate;
              } else if (key === 'individual') {
                if (Array.isArray(data[key])) {
                  for (let individual of data[key]) {
                    data[individual] = (this.lang === 'en' ? 'Yes' : 'Ja');
                  }
                } else {
                  let individuals;
                  try {
                    individuals = data[key] ? JSON.parse(data[key]) : null;
                  } catch (e) {
                    individuals = null;
                  }

                  if (Array.isArray(individuals)) {
                    for (let individual of individuals) {
                      if (individual.answer === true || individual.answer === "true" || individual.answer === "") {
                        data[individual.question] = (this.lang === 'en' ? 'Yes' : 'Ja');
                      } else {
                        data[individual.question] = individual.answer || "";
                      }
                    }
                  }
                }
                delete data[key];
              } else if (key === 'passport') {
                let _passportData = data[key].split(' ');
                if (_passportData.length >= 2) {
                  data[key] = _passportData[0];
                  data['expiry_date'] = moment(_passportData[1]).format('DD.MM.YYYY');
                }
              } else if (key === 'birth_date') {
                data[key] = moment(data[key]).format('DD.MM.YYYY');
              }
            });
            user = Object.assign(user, data);
          }
        } else {
          let yes = this.tr.instant('yes');
          let no = this.tr.instant('no');
          user = {
            Vorname: el.firstName,
            Nachname: el.lastName,
            Organisation: '',
            'Name der Kirchgemeinde': el.orgName,
            Zielgruppe: '',
            Telefon: el.phone,
            'Mobile-Nr.' : el.mobile,
            'E-Mail': el.email,
            Geschlecht: el.gender,
            Registrierungsdatum: moment(el.createdAt).format('DD.MM.YYYY '),
            Registrierungszeit: moment(el.createdAt).format('HH:mm'),
            Strasse: el.street,
            Hausnummer: el.number,
            PLZ: el.postcode,
            Ort: el.cityName,
            Gruppenanmeldung: el.groupRegistration ? yes : no,
            'Name_der_Organisation': el.nameOfOrganization,
            'Anzahl_der_Personen': el.numberOfPeople,
            'M/Vorname': '',
            'M/Nachname': '',
            'M/Strasse': '',
            'M/Hausnummer': '',
            'M/PLZ': '',
            'M/Ort': '',
            'M/Telefon': '',
            'M/Mobile-Nr.': '',
            'M/E-Mail':  '',
            'V/Vorname': '',
            'V/Nachname': '',
            'V/Strasse': '',
            'V/Hausnummer': '',
            'V/PLZ': '',
            'V/Ort':  '',
            'V/Telefon': '',
            'V/Mobile-Nr.': '',
            'V/E-Mail': ''
          };
          user = Object.assign(user, allGuestTitles);
          user.individual = '';
          if (el.data) {
            let data = JSON.parse(el.data);
            let _keys = Object.keys(data);
            _keys.forEach(key => {
              if (data[key] === true || data[key] === 'true') {
                let translate = this.tr.instant('yes');
                data[key] = translate;
              } else if (data[key] === false || data[key] === 'false') {
                let translate = this.tr.instant('no');
                data[key] = translate;
              } else if (key === 'individual') {
                if (Array.isArray(data[key])) {
                  for (let individual of data[key]) {
                    data[individual] = (this.lang === 'en' ? 'Yes' : 'Ja');
                  }
                } else {
                  let individuals;
                  try {
                    individuals = data[key] ? JSON.parse(data[key]) : null;
                  } catch (e) {
                    individuals = null;
                  }

                  if (Array.isArray(individuals)) {
                    for (let individual of individuals) {
                      if (individual.answer === true || individual.answer === "true" || individual.answer === "") {
                        data[individual.question] = (this.lang === 'en' ? 'Yes' : 'Ja');
                      } else {
                        data[individual.question] = individual.answer || "";
                      }
                    }
                  }
                }
                delete data[key];
              } else if (key === 'passport') {
                let _passportData = data[key].split(' ');
                if (_passportData.length >= 2) {
                  data[key] = _passportData[0];
                  data['expiry_date'] = moment(_passportData[1]).format('DD.MM.YYYY');
                }
              } else if (key === 'birth_date') {
                data[key] = moment(data[key]).format('DD.MM.YYYY');
              }
            });
            user = Object.assign(user, data);
          }
        }
        return user;
      });

      const replacer = (key, value) => value === null ? '' : value; // specify how you want to handle null values here
     
      //const header = Object.keys(_csvArray[0]);
      
      let allKeys = new Set<string>();
      _csvArray.forEach(user => {
        Object.keys(user).forEach(key => allKeys.add(key));
      });
      const header: string[] = Array.from(allKeys);

      
      
      let csv = _csvArray.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
      let worksheetHeader = header.map(el => {
        let _title: any = this.tr.instant('guestModal.' + el);
        if (_title === 'guestModal.' + el) {
          _title = el;
        }
        _title = _title.replace(/,/g, '/');
        return  _title;
      });
      csv.unshift(worksheetHeader.join(','));
      let csvArray = csv.join('\r\n');
      let blob = new Blob([csvArray], {type: 'text/csv;charset=windows-1252;' });
      fileSaver.saveAs(blob, 'myFile.csv');
    });
  }

  downloadXLSX() {
    if (!this.eventData.additionalForm) {
      let _csvArray = this.usersForCSV.map((el) => {
        let user = {};
        if (el.frontUserId) {
          user = {
            Vorname: el.frontUser.firstName,
            Nachname: el.frontUser.lastName,
            Organisation: el.frontUser.organization.name,
            Zielgruppe: (el.frontUser.targetGroup && el.frontUser.targetGroup.ageMask) ? el.frontUser.targetGroup.ageMask : '',
            Telefon: el.frontUser.phone,
            'Mobile-Nr.' : el.frontUser.mobile,
            'E-Mail': el.frontUser.email,
            Geschlecht: el.frontUser.gender,
            Registrierungsdatum: moment(el.createdAt).format(' DD.MM.YYYY '),
            Registrierungszeit: moment(el.createdAt).format('HH:mm'),
            Strasse: el.frontUser.street,
            Hausnummer: el.frontUser.number,
            PLZ: el.frontUser.postcode,
            Ort: el.frontUser.cityLocation,
            Gruppenanmeldung: '',
            'Name_der_Organisation': '',
            'Anzahl_der_Personen': '',
            'M/Vorname': el.mother ? el.mother.firstName : '',
            'M/Nachname': el.mother ? el.mother.lastName : '',
            'M/Strasse': el.mother ? el.mother.street : '',
            'M/Hausnummer': el.mother ? el.mother.number : '',
            'M/PLZ': el.mother ? el.mother.postcode : '',
            'M/Ort': el.mother ? el.mother.cityLocation : '',
            'M/Telefon': el.mother ? el.mother.phone : '',
            'M/Mobile-Nr.': el.mother ? el.mother.mobile : '',
            'M/E-Mail': el.mother ? el.mother.email : '',
            'V/Vorname': el.father ? el.father.firstName : '',
            'V/Nachname': el.father ? el.father.lastName : '',
            'V/Strasse': el.father ? el.father.street : '',
            'V/Hausnummer': el.father ? el.father.number : '',
            'V/PLZ': el.father ? el.father.postcode : '',
            'V/Ort': el.father ? el.father.cityLocation : '',
            'V/Telefon': el.father ? el.father.phone : '',
            'V/Mobile-Nr.': el.father ? el.father.mobile : '',
            'V/E-Mail': el.father ? el.father.email : ''
          };
        } else {
          let yes = this.tr.instant('yes');
          let no = this.tr.instant('no');
          user = {
            Vorname: el.firstName,
            Nachname: el.lastName,
            Organisation: '',
            Zielgruppe: '',
            Telefon: el.phone,
            'Mobile-Nr.' : el.mobile,
            'E-Mail': el.email,
            Geschlecht: el.gender,
            Registrierungsdatum: moment(el.createdAt).format('DD.MM.YYYY '),
            Registrierungszeit: moment(el.createdAt).format('HH:mm'),
            Strasse: el.street,
            Hausnummer: el.number,
            PLZ: el.postcode,
            Ort: el.cityName,
            Gruppenanmeldung: el.groupRegistration ? yes : no,
            'Name_der_Organisation': el.nameOfOrganization,
            'Anzahl_der_Personen': el.numberOfPeople,
            'M/Vorname': '',
            'M/Nachname': '',
            'M/Strasse': '',
            'M/Hausnummer': '',
            'M/PLZ': '',
            'M/Ort': '',
            'M/Telefon': '',
            'M/Mobile-Nr.': '',
            'M/E-Mail':  '',
            'V/Vorname': '',
            'V/Nachname': '',
            'V/Strasse': '',
            'V/Hausnummer': '',
            'V/PLZ': '',
            'V/Ort':  '',
            'V/Telefon': '',
            'V/Mobile-Nr.': '',
            'V/E-Mail': ''
          };
        }
        return user;
      });
      
      let allKeys = new Set<string>();
      _csvArray.forEach(user => {
        Object.keys(user).forEach(key => allKeys.add(key));
      });
      const header: string[] = Array.from(allKeys);

      
      let workbook = new ExcelJS.Workbook();

      workbook.creator = 'Ipeak';
      workbook.lastModifiedBy = 'Ipeak';
      workbook.created = new Date();
      workbook.modified = new Date();
      workbook.lastPrinted = new Date();
      workbook.properties.date1904 = true;

      workbook.views = [
        {
          x: 0, y: 0, width: 10000, height: 20000,
          firstSheet: 0, activeTab: 1, visibility: 'visible'
        }
      ];
      let worksheet = workbook.addWorksheet('My Sheet');
      let worksheetHeader = header.map(el => {
        return {header: el, key: el, width: 32};
      });
      worksheet.columns = worksheetHeader;
      worksheet.addRows(_csvArray);
      workbook.xlsx.writeBuffer()
        .then((data) => {
          let blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          fileSaver.saveAs(blob, 'myFile.xlsx');
        });
    } else {
      this.getTableInfoXlSX();
    }
  }

  getTableInfoXlSX() {
    this.eventService.getTableInfoById(this.eventData.guestData).subscribe((res: any) => {
      let allGuestTitles: any = {};
      if (res && res.length) {
        res.forEach(el => {
          allGuestTitles[el.name] = '';
        });
      }
      if (allGuestTitles && allGuestTitles.hasOwnProperty('passport')) {
        allGuestTitles = this.addToObject(allGuestTitles, 'expiry_date', '', 1);
      }
      let _csvArray = this.usersForCSV.map((el) => {
        let user: any = {};
        if (el.frontUserId) {
          user = {
            Vorname: el.frontUser.firstName,
            Nachname: el.frontUser.lastName,
            Organisation: el.frontUser.organization.name,
            'Name der Kirchgemeinde': '',
            Zielgruppe: (el.frontUser.targetGroup && el.frontUser.targetGroup.ageMask) ? el.frontUser.targetGroup.ageMask : '',
            Telefon: el.frontUser.phone,
            'Mobile-Nr.' : el.frontUser.mobile,
            'E-Mail': el.frontUser.email,
            Geschlecht: el.frontUser.gender,
            Registrierungsdatum: moment(el.createdAt).format('DD.MM.YYYY '),
            Registrierungszeit: moment(el.createdAt).format('HH:mm'),
            Strasse: el.frontUser.street,
            Hausnummer: el.frontUser.number,
            PLZ: el.frontUser.postcode,
            Ort: el.frontUser.cityLocation,
            Gruppenanmeldung: '',
            'Name_der_Organisation': '',
            'Anzahl_der_Personen': '',
            'M/Vorname': el.mother ? el.mother.firstName : '',
            'M/Nachname': el.mother ? el.mother.lastName : '',
            'M/Strasse': el.mother ? el.mother.street : '',
            'M/Hausnummer': el.mother ? el.mother.number : '',
            'M/PLZ': el.mother ? el.mother.postcode : '',
            'M/Ort': el.mother ? el.mother.cityLocation : '',
            'M/Telefon': el.mother ? el.mother.phone : '',
            'M/Mobile-Nr.': el.mother ? el.mother.mobile : '',
            'M/E-Mail': el.mother ? el.mother.email : '',
            'V/Vorname': el.father ? el.father.firstName : '',
            'V/Nachname': el.father ? el.father.lastName : '',
            'V/Strasse': el.father ? el.father.street : '',
            'V/Hausnummer': el.father ? el.father.number : '',
            'V/PLZ': el.father ? el.father.postcode : '',
            'V/Ort': el.father ? el.father.cityLocation : '',
            'V/Telefon': el.father ? el.father.phone : '',
            'V/Mobile-Nr.': el.father ? el.father.mobile : '',
            'V/E-Mail': el.father ? el.father.email : ''
          };
          user = Object.assign(user, allGuestTitles);
          if (el.data && el.data.data) {
            let data = JSON.parse(el.data.data);
            let _keys = Object.keys(data);
            _keys.forEach(key => {
              if (data[key] === true || data[key] === 'true') {
                let translate = this.tr.instant('yes');
                data[key] = translate;
              } else if (data[key] === false || data[key] === 'false') {
                let translate = this.tr.instant('no');
                data[key] = translate;
              } else if (key === 'individual') {
                if (Array.isArray(data[key])) {
                  for (let individual of data[key]) {
                    data[individual] = (this.lang === 'en' ? 'Yes' : 'Ja');
                  }
                } else {
                  let individuals = JSON.parse(data[key]);
                  if (individuals && individuals.length > 0) {
                    for (let individual of individuals) {
                      if (individual.answer) {
                        data[individual.question] = individual.answer;
                      } else {
                        data[individual.question] = (this.lang === 'en' ? 'Yes' : 'Ja');
                      }
                    }
                  }
                }
                delete data[key];
              } else if (key === 'passport') {
                let _passportData = data[key].split(' ');
                if (_passportData.length >= 2) {
                  data[key] = _passportData[0];
                  data['expiry_date'] = moment(_passportData[1]).format('DD.MM.YYYY');
                }
              } else if (key === 'birth_date') {
                data[key] = moment(data[key]).format('DD.MM.YYYY');
              }
            });
            user = Object.assign(user, data);
          }
        } else {
          let yes = this.tr.instant('yes');
          let no = this.tr.instant('no');
          user = {
            Vorname: el.firstName,
            Nachname: el.lastName,
            Organisation: '',
            'Name der Kirchgemeinde': el.organizationName,
            Zielgruppe: '',
            Telefon: el.phone,
            'Mobile-Nr.' : el.mobile,
            'E-Mail': el.email,
            Geschlecht: el.gender,
            Registrierungsdatum: moment(el.createdAt).format('DD.MM.YYYY '),
            Registrierungszeit: moment(el.createdAt).format('HH:mm'),
            Strasse: el.street,
            Hausnummer: el.number,
            PLZ: el.postcode,
            Ort: el.cityName,
            Gruppenanmeldung: el.groupRegistration ? yes : no,
            'Name_der_Organisation': el.nameOfOrganization,
            'Anzahl_der_Personen': el.numberOfPeople,
            'M/Vorname': '',
            'M/Nachname': '',
            'M/Strasse': '',
            'M/Hausnummer': '',
            'M/PLZ': '',
            'M/Ort': '',
            'M/Telefon': '',
            'M/Mobile-Nr.': '',
            'M/E-Mail':  '',
            'V/Vorname': '',
            'V/Nachname': '',
            'V/Strasse': '',
            'V/Hausnummer': '',
            'V/PLZ': '',
            'V/Ort':  '',
            'V/Telefon': '',
            'V/Mobile-Nr.': '',
            'V/E-Mail': ''
          };
          user = Object.assign(user, allGuestTitles);
          if (el.data) {
            let data = JSON.parse(el.data);
            let _keys = Object.keys(data);
            _keys.forEach(key => {
              if (data[key] === true || data[key] === 'true') {
                let translate = this.tr.instant('yes');
                data[key] = translate;
              } else if (data[key] === false || data[key] === 'false') {
                let translate = this.tr.instant('no');
                data[key] = translate;
              } else if (key === 'individual') {
                if (Array.isArray(data[key])) {
                  for (let individual of data[key]) {
                    data[individual] = (this.lang === 'en' ? 'Yes' : 'Ja');
                  }
                } else {
                  let individuals = JSON.parse(data[key]);
                  if (individuals && individuals.length > 0) {
                    for (let individual of individuals) {
                      if (individual.answer) {
                        data[individual.question] = individual.answer;
                      } else {
                        data[individual.question] = (this.lang === 'en' ? 'Yes' : 'Ja');
                      }
                    }
                  }
                }
                delete data[key];
              } else if (key === 'passport') {
                let _passportData = data[key].split(' ');
                if (_passportData.length >= 2) {
                  data[key] = _passportData[0];
                  data['expiry_date'] = moment(_passportData[1]).format('DD.MM.YYYY');
                }
              } else if (key === 'birth_date' && data[key]) {
                data[key] = moment(data[key]).format('DD.MM.YYYY');
              }
            });
            user = Object.assign(user, data);
          }
        }
        return user;
      });
      
      //const header = Object.keys(_csvArray[0]);
      
         let allKeys = new Set<string>();
      _csvArray.forEach(user => {
        Object.keys(user).forEach(key => allKeys.add(key));
      });
      const header: string[] = Array.from(allKeys);
      
      let workbook = new ExcelJS.Workbook();

      workbook.creator = 'Ipeak';
      workbook.lastModifiedBy = 'Ipeak';
      workbook.created = new Date();
      workbook.modified = new Date();
      workbook.lastPrinted = new Date();
      workbook.properties.date1904 = true;

      workbook.views = [
        {
          x: 0, y: 0, width: 10000, height: 20000,
          firstSheet: 0, activeTab: 1, visibility: 'visible'
        }
      ];
      let worksheet = workbook.addWorksheet('My Sheet');
      let worksheetHeader = header.map(el => {
        let _title = this.tr.instant('guestModal.' + el);
        if (_title === 'guestModal.' + el) {
          _title = el;
        }
        return {header: _title, key: el, width: 32};
      });
      worksheet.columns = worksheetHeader;
      worksheet.addRows(_csvArray);
      workbook.xlsx.writeBuffer()
        .then((data) => {
          let blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          fileSaver.saveAs(blob, 'myFile.xlsx');
        });
    });
  }

  addToObject(obj, key, value, index) {

    // Create a temp object and index variable
    let temp = {};
    let i = 0;

    // Loop through the original object
    for (let prop in obj) {
      if (obj.hasOwnProperty(prop)) {

        // If the indexes match, add the new item
        if (i === index && key) {
          temp[key] = value;
        }

        // Add the current item in the loop to the temp obj
        temp[prop] = obj[prop];

        // Increase the count
        i++;

      }
    }

    // If no index, add to the end
    if (!index && key && value) {
      temp[key] = value;
    }

    return temp;
  }

  openDialogAction (): void {
    const dialogRef = this.dialog.open(DialogActionNew , {
      width: 'auto' ,
      data: this.eventData
    });
    this.subscription.add(dialogRef.afterClosed().subscribe(result => {
      if (result === 'printList') {
        this.print();
      }
      if (result === 'printCode') {
        this.downloadPDF('print');
      }
      if (result === 'downloadCode') {
        this.downloadPDF('download');
      }
      if (result === 'downloadCSV') {
        this.downloadCSV();
      }
      if (result === 'downloadXLSX') {
        this.downloadXLSX();
      }
      if (result === 'downloadAllPDF') {
        this.downloadAllPDF2();
      }
    }));
  }

  downloadAllPDF2() {
    this.spinner.show();
    let users = this.usersForCSV;
    let eventId = this.eventID;
    if (this.eventData.guestEvent && this.eventData.additionalForm) {
      this.eventService.getAllGuestUserData(eventId).subscribe((res: any) => {
        this.eventService.getRowsForGuestEvent().subscribe((result: any) => {
          if (res && result) {
            const doc = new jsPDF();
            for (let i = 0; i < users.length; i++) {
              if (i !== 0 ) {
                doc.addPage('a4');
              }
              let _user;
              if (users[i].frontUserId) {
                _user = res.find(el => el.isFrontUser && +el.userId === +users[i].frontUserId);
              } else {
                _user = res.find(el => !el.isFrontUser && +el.userId === +users[i].guestUserId);
              }
              if (_user && _user.data) {
                users[i].pdfData = JSON.parse(_user.data);
                let keys = Object.keys(users[i].pdfData);
                let array = [];
                for (let k = 0; k < keys.length; k++) {
                  if (keys[k] === 'birth_date' && users[i].pdfData[keys[k]] !== '') {
                    users[i].pdfData[keys[k]] = moment(users[i].pdfData[keys[k]]).format('DD.MM.YYYY');
                  }
                  if (keys[k] === 'passport' && users[i].pdfData[keys[k]] !== '') {
                    users[i].pdfData[keys[k]] = users[i].pdfData[keys[k]].split(' ')[0] + ' ' + moment(users[i].pdfData[keys[k]].split(' ')[1]).format('DD.MM.YYYY');
                  }
                  if (!users[i].pdfData[keys[k]] || users[i].pdfData[keys[k]] === '') {
                    delete users[i].pdfData[keys[k]];
                  } else {
                    let title = result.filter(info => info.name === keys[k]);
                    if (title && title.length) {
                      let obj = {
                        data: users[i].pdfData[keys[k]],
                        name: keys[k],
                        title: title[0].title,
                        titleId: title[0].titleId
                      };
                      array.push(obj);
                    }
                  }
                }
                if (users[i].pdfData.hasOwnProperty('individual')) {
                  let obj = {
                    data: users[i].pdfData['individual'],
                    name: 'individual',
                    title: 'individuals',
                    titleId: 12
                  };
                  array.push(obj);
                }
                keys = Object.keys(users[i].pdfData);
                let name = users[i].frontUserId ? users[i].frontUser.lastName + ' ' + users[i].frontUser.firstName :
                  users[i].lastName + ' ' + users[i].firstName;
                let email = users[i].frontUserId ? users[i].frontUser.email :
                  users[i].email;
                doc.setFontSize(24);
                doc.setFont('bold');
                doc.text(name, 20 , 20);

                doc.setFontSize(14);
                doc.setFont('italic');
                doc.text(email, 10 , 30);

                let margin = 40;
                let count = 0;
                let title = '';
                for (let ar = 0; ar < array.length; ar++) {
                  let splitAllText = [];
                  if (title !== array[ar].title) {
                    title = array[ar].title;
                    let _title = this.tr.instant('guestModal.' + title);
                    doc.setFontSize(14);
                    doc.setFont('bold');
                    doc.text(_title, 10 , count * 7 + margin);
                    count++;
                  }
                  if (array[ar].name !== 'individual') {
                    let text = this.tr.instant('guestModal.' + keys[ar]);
                    let value = array[ar].data === true ? this.lang === 'en' ? 'Yes' : 'Ja' : array[ar].data;
                    let _allText = text + ': ' + value;
                    splitAllText = doc.splitTextToSize(_allText, 230);
                    doc.setTextColor('black');
                    doc.setFontSize(12);
                    doc.setFont('normal');
                    doc.text(splitAllText, 20 , count * 7 + margin);
                  } else {
                    if (Array.isArray(array[ar].data)) {
                      let individual = array[ar].data;
                      if (individual.length) {
                        for (let y = 0; y < individual.length; y++) {
                          let text = individual[y];
                          let value = this.lang === 'en' ? 'Yes' : 'Ja';
                          let _allText = text + ': ' + value;
                          splitAllText = doc.splitTextToSize(_allText, 230);
                          doc.setTextColor('black');
                          doc.setFontSize(12);
                          doc.setFont('normal');
                          doc.text(splitAllText, 20, count * 7 + margin + (y) * 7);
                          if (count * 7 + margin + (y) * 7 > 270) {
                            doc.addPage('a4');
                            count = 1;
                            margin = 0;
                          }
                        }
                      }
                    } else {
                      let individual = JSON.parse(array[ar].data);
                      if (individual.length) {
                        for (let y = 0; y < individual.length; y++) {
                          let text = individual[y].answer ? individual[y].question + ' : ' + individual[y].answer :
                            individual[y].question + (this.lang === 'en' ? ' : Yes' : ' : Ja');
                          splitAllText = doc.splitTextToSize(text, 190);
                          doc.setTextColor('black');
                          doc.setFontSize(12);
                          doc.setFont('normal');
                          doc.text(splitAllText, 20, count * 7 + margin + (y) * 7);
                          if (splitAllText.length) {
                            count = count + (Math.round(splitAllText.length * 0.8) - 1);
                          }
                          if (count * 7 + margin + (y) * 7 > 290) {
                            doc.addPage('a4');
                            count = 1;
                            margin = 0;
                          }
                        }
                      }
                    }
                  }
                  if (count * 7 + margin > 270) {
                    doc.addPage('a4');
                    count = 1;
                    margin = 0;
                  }
                  if (splitAllText.length) {
                    count = count + splitAllText.length;
                  } else {
                    count++;
                  }
                }
              } else {
                let name = users[i].frontUserId ? users[i].frontUser.lastName + ' ' + users[i].frontUser.firstName :
                  users[i].lastName + ' ' + users[i].firstName;
                let email = users[i].frontUserId ? users[i].frontUser.email :
                  users[i].email;
                doc.setFontSize(24);
                doc.setFont('bold');
                doc.text(name, 20 , 20);

                doc.setFontSize(14);
                doc.setFont('italic');
                doc.text(email, 10 , 30);
              }
            }
            doc.save('all.pdf');
            this.spinner.hide();
          }
        }, error1 => {
          this.spinner.hide();
        });
      }, error => {
        this.spinner.hide();
      });
    }
    if (!this.eventData.guestEvent && this.eventData.additionalForm) {
      let ids = [];
      this.usersForCSV.forEach(el => {
        ids.push(+el.frontUserId);
      });
      this.eventService.getAllAdditionalData(ids, eventId).subscribe((res: any) => {
        this.eventService.getRowsForGuestEvent().subscribe((result: any) => {
          if (res && result) {
            const doc = new jsPDF();
            for (let i = 0; i < users.length; i++) {
              if (i !== 0 ) {
                doc.addPage('a4');
              }
              let _user;
              if (users[i].frontUserId) {
                _user = res.find(el => +el.userId === +users[i].frontUserId);
              } else {
                _user = res.find(el => +el.userId === +users[i].guestUserId);
              }
              if (_user && _user.data) {
                users[i].pdfData = JSON.parse(_user.data);
                let keys = Object.keys(users[i].pdfData);
                let array = [];
                for (let k = 0; k < keys.length; k++) {
                  if (keys[k] === 'birth_date' && users[i].pdfData[keys[k]] !== '') {
                    users[i].pdfData[keys[k]] = moment(users[i].pdfData[keys[k]]).format('DD.MM.YYYY');
                  }
                  if (keys[k] === 'passport' && users[i].pdfData[keys[k]] !== '') {
                    users[i].pdfData[keys[k]] = users[i].pdfData[keys[k]].split(' ')[0] + ' ' + moment(users[i].pdfData[keys[k]].split(' ')[1]).format('DD.MM.YYYY');
                  }
                  if (!users[i].pdfData[keys[k]] || users[i].pdfData[keys[k]] === '') {
                    delete users[i].pdfData[keys[k]];
                  } else {
                    let title = result.filter(info => info.name === keys[k]);
                    if (title && title.length) {
                      let obj = {
                        data: users[i].pdfData[keys[k]],
                        name: keys[k],
                        title: title[0].title,
                        titleId: title[0].titleId
                      };
                      array.push(obj);
                    }
                  }
                }
                if (users[i].pdfData.hasOwnProperty('individual')) {
                  let obj = {
                    data: users[i].pdfData['individual'],
                    name: 'individual',
                    title: 'individuals',
                    titleId: 12
                  };
                  array.push(obj);
                }
                keys = Object.keys(users[i].pdfData);
                let name = users[i].frontUserId ? users[i].frontUser.lastName + ' ' + users[i].frontUser.firstName :
                  users[i].lastName + ' ' + users[i].firstName;
                let email = users[i].frontUserId ? users[i].frontUser.email :
                  users[i].email;
                doc.setFontSize(24);
                doc.setFont('bold');
                doc.text(name, 20 , 20);

                doc.setFontSize(14);
                doc.setFont('italic');
                doc.text(email, 10 , 30);

                let margin = 40;
                let count = 0;
                let title = '';
                for (let ar = 0; ar < array.length; ar++) {
                  let splitAllText = [];
                  if (title !== array[ar].title) {
                    title = array[ar].title;
                    let _title = this.tr.instant('guestModal.' + title);
                    doc.setFontSize(14);
                    doc.setFont('bold');
                    doc.text(_title, 10 , count * 7 + margin);
                    count++;
                  }
                  if (array[ar].name !== 'individual') {
                    let text = this.tr.instant('guestModal.' + keys[ar]);
                    let value = array[ar].data === true ? this.lang === 'en' ? 'Yes' : 'Ja' : array[ar].data;
                    let _allText = text + ': ' + value;
                    splitAllText = doc.splitTextToSize(_allText, 230);
                    doc.setTextColor('black');
                    doc.setFontSize(12);
                    doc.setFont('normal');
                    doc.text(splitAllText, 20 , count * 7 + margin);
                  } else {
                    let individual = array[ar].data;
                    if (individual.length) {
                      for (let y = 0; y < individual.length; y++) {
                        let text = individual[y];
                        let value = this.lang === 'en' ? 'Yes' : 'Ja';
                        let _allText = text + ': ' + value;
                        splitAllText = doc.splitTextToSize(_allText, 230);
                        doc.setTextColor('black');
                        doc.setFontSize(12);
                        doc.setFont('normal');
                        doc.text(splitAllText, 20, count * 7 + margin + (y) * 7);
                        if (count * 7 + margin + (y) * 7 > 270) {
                          doc.addPage('a4');
                          count = 1;
                          margin = 0;
                        }
                      }
                    }
                  }
                  if (count * 7 + margin > 270) {
                    doc.addPage('a4');
                    count = 1;
                    margin = 0;
                  }
                  if (splitAllText.length) {
                    count = count + splitAllText.length;
                  } else {
                    count++;
                  }
                }
              } else {
                let name = users[i].frontUserId ? users[i].frontUser.lastName + ' ' + users[i].frontUser.firstName :
                  users[i].lastName + ' ' + users[i].firstName;
                let email = users[i].frontUserId ? users[i].frontUser.email :
                  users[i].email;
                doc.setFontSize(24);
                doc.setFont('bold');
                doc.text(name, 20 , 20);

                doc.setFontSize(14);
                doc.setFont('italic');
                doc.text(email, 10 , 30);
              }
            }
            doc.save('all.pdf');
            this.spinner.hide();
          }
        }, error1 => {
          this.spinner.hide();
        });
      }, error => {
        this.spinner.hide();
      });
    }

  }

  ngOnDestroy () {
    this.subscription.unsubscribe();
  }
}


@Component({
    selector: 'dialog-overview',
    templateUrl: 'dialog.html',
    styleUrls: ['./participant.scss'],
    standalone: true,
  imports: [SharedModule]
})
export class DialogOverview {
  static dataWasChanged = false;
  userData;
  keys;
  lang;
  array = [];
  targetGroups = [];
  editTarget = false;
  selectedTG;
  userId;

  eventId;
  constructor (public dialogRef: MatDialogRef<DialogOverview> ,
               @Inject(MAT_DIALOG_DATA) public data, private spinner: NgxSpinnerService,  public eventService: EventService,
               public tr: TranslateService, public dialog: MatDialog, public frontUserService: FrontUserService,
               public toastr: ToastrService) {
    this.lang = this.tr.currentLang;
    let id = data.user.frontUserId ? data.user.frontUserId : data.user.guestUserId;
    let isFront = data.user.frontUserId ? true : false;
    let eventId = data.user.eventId;
    this.eventId = data.user.eventId;
    if (isFront) {
      this.userId = data.user.frontUserId;
      this.getTG();
    }
    if (data.user && data.user.targetGroupId) {
      this.selectedTG = data.user.targetGroupId;
    }
    if (id && ((data.user.event && data.user.event.guestEvent && data.user.event.additionalForm) || !isFront)) {
      this.eventService.getGuestUserData(id, isFront, eventId).subscribe((res: any) => {
        if (res && res.data) {
          this.array = [];
          this.userData = JSON.parse(res.data);
          this.keys = Object.keys(this.userData);

          this.eventService.getRowsForGuestEvent().subscribe((result: any) => {
            this.keys.forEach(el => {
              if (el === 'birth_date' && this.userData[el] !== '') {
                this.userData[el] = moment(this.userData[el]).format('DD.MM.YYYY');
              }
              if (el === 'passport' && this.userData[el] !== '') {
                this.userData[el] = this.userData[el].split(' ')[0] + ' ' + moment(this.userData[el].split(' ')[1]).format('DD.MM.YYYY');
              }
              if (!this.userData[el] || this.userData[el] === '') {
                delete this.userData[el];
              } else {
                let title = result.filter(info => info.name === el);
                if (title && title.length) {
                  let obj = {
                    data: this.userData[el],
                    name: el,
                    title: title[0].title,
                    titleId: title[0].titleId
                  };
                  this.array.push(obj);
                }
              }
            });
            if (this.userData.hasOwnProperty('individual')) {
              let obj = {
                data: this.userData['individual'],
                name: 'individual',
                title: 'individuals',
                titleId: 12
              };
              this.array.push(obj);
            }
            this.keys = Object.keys(this.userData);
          });
        }
      });
    }
    if (id && data.user.event && (!data.user.event.guestEvent && data.user.event.additionalForm)) {
      this.eventService.getAdditionalData(id, eventId).subscribe((res: any) => {
        if (res && res.data) {
          this.array = [];
          this.userData = JSON.parse(res.data);
          this.keys = Object.keys(this.userData);

          this.eventService.getRowsForGuestEvent().subscribe((result: any) => {
            this.keys.forEach(el => {
              if (el === 'birth_date' && this.userData[el] !== '') {
                this.userData[el] = moment(this.userData[el]).format('DD.MM.YYYY');
              }
              if (el === 'passport' && this.userData[el] !== '') {
                this.userData[el] = this.userData[el].split(' ')[0] + ' ' + moment(this.userData[el].split(' ')[1]).format('DD.MM.YYYY');
              }
              if (!this.userData[el] || this.userData[el] === '') {
                delete this.userData[el];
              } else {
                let title = result.filter(info => info.name === el);
                if (title && title.length) {
                  let obj = {
                    data: this.userData[el],
                    name: el,
                    title: title[0].title,
                    titleId: title[0].titleId
                  };
                  this.array.push(obj);
                }
              }
            });
            if (this.userData.hasOwnProperty('individual')) {
              let obj = {
                data: this.userData['individual'],
                name: 'individual',
                title: 'individuals',
                titleId: 12
              };
              this.array.push(obj);
            }
            this.keys = Object.keys(this.userData);
          });
        }
      });
    }
  }

  getImage(name) {
    return this.eventService.getFileStream(name);
  }

  editTG() {
    this.editTarget = true;
  }

  saveTG() {
    this.editTarget = false;
    this.frontUserService.editParticipantTG({id: this.userId, tgId: this.selectedTG, eventId: this.eventId}).subscribe((res: any) => {
      if (res && res.error && res.error === 'userNotFound') {
        this.toastr.error('User not found!' , 'Error!');
      }
      if (res && res.id) {
        this.toastr.success('Zielgruppe angepasst!' , 'Erfolgreich!');
        DialogOverview.dataWasChanged = true;
        this.dialogRef.close();
      }
    });

  }

  cancelEditTG() {
    this.editTarget = false;
  }

  getTG() {
    this.spinner.show();
    this.frontUserService.getTargetGroup(false).subscribe((res: any) => {
      if (res && res.targetGroups) {
        this.targetGroups = res.targetGroups;
        this.spinner.hide();
      }
    });
  }

  downloadPDF() {
    this.spinner.show();
    let name = this.data.frontUserId ? this.data.frontUser.lastName + ' ' + this.data.frontUser.firstName :
      this.data.lastName + ' ' + this.data.firstName;
    let email = this.data.frontUserId ? this.data.frontUser.email :
      this.data.email;
    const doc = new jsPDF();

    doc.setFontSize(24);
    doc.setFont('bold');
    doc.text(name, 20 , 20);

    doc.setFontSize(14);
    doc.setFont('italic');
    doc.text(email, 10 , 30);
    let margin = 40;
    let count = 0;
    for (let i = 0; i < this.keys.length; i++) {
      if (this.userData[this.keys[i]] && this.userData[this.keys[i]] !== '') {
        if (this.keys[i] !== 'individual') {
          let text = this.tr.instant('guestModal.' + this.keys[i]);
          let value  = this.userData[this.keys[i]] === true ? this.lang === 'en' ? 'Yes' : 'Ja' : this.userData[this.keys[i]];
          doc.setTextColor('black');
          doc.setFontSize(12);
          doc.setFont('normal');
          doc.text(text + ': ' + value, 10 , count * 7 + margin);
        } else {
          let individual =  this.userData[this.keys[i]];
          if (individual.length) {
            let text = this.tr.instant('guestModal.' + this.keys[i]);
            doc.setTextColor('black');
            doc.setFontSize(12);
            doc.setFont('normal');
            doc.text(text + ':', 10 , count * 7 + margin);
            for (let y = 0; y < individual.length; y++) {
              let text = individual[y];
              let value  = this.lang === 'en' ? 'Yes' : 'Ja';
              doc.setTextColor('black');
              doc.setFontSize(12);
              doc.setFont('normal');
              doc.text(text + ': ' + value, 20 , count * 7 + margin + (y + 1) * 7);
              if (count * 7 + margin + (y + 1) * 7 > 270) {
                doc.addPage('a4');
                count = 1;
                margin = 0;
              }
            }
          }
        }
        if (count * 7 + margin > 270) {
          doc.addPage('a4');
          count = 1;
          margin = 0;
        }
        count++;
      }
    }
    let filename = this.data.frontUserId ? this.data.frontUser.lastName + '_' + this.data.frontUser.firstName :
      this.data.lastName + '_' + this.data.firstName;
    doc.save(filename + '.pdf');
    this.spinner.hide();
  }

  downloadPDF2() {
    this.spinner.show();
    let name = this.data.user.frontUserId ? this.data.user.frontUser.lastName + ' ' + this.data.user.frontUser.firstName :
      this.data.user.lastName + ' ' + this.data.user.firstName;
    let email = this.data.user.frontUserId ? this.data.user.frontUser.email :
      this.data.user.email;
    const doc = new jsPDF();

    doc.setFontSize(24);
    doc.setFont('bold');
    doc.text(name, 20 , 20);

    doc.setFontSize(14);
    doc.setFont('italic');
    doc.text(email, 10 , 30);
    let margin = 40;
    let count = 0;
    let title = '';
    for (let i = 0; i < this.array.length; i++) {
      let splitAllText = [];
      if (title !== this.array[i].title) {
        title = this.array[i].title;
        let _title = this.tr.instant('guestModal.' + title);
        doc.setFontSize(14);
        doc.setFont('bold');
        doc.text(_title, 10 , count * 7 + margin);
        count++;
      }
      if (this.array[i].name !== 'individual') {
        let text = this.tr.instant('guestModal.' + this.keys[i]);
        let value = this.array[i].data === true ? this.lang === 'en' ? 'Yes' : 'Ja' : this.array[i].data;
        let _allText = text + ': ' + value;
        splitAllText = doc.splitTextToSize(_allText, 230);
        doc.setTextColor('black');
        doc.setFontSize(12);
        doc.setFont('normal');
        doc.text(splitAllText, 20 , count * 7 + margin);
      } else {
        if (Array.isArray(this.array[i].data)) {
          let individual = this.array[i].data;
          if (individual.length) {
            for (let y = 0; y < individual.length; y++) {
              let text = individual[y];
              let value = this.lang === 'en' ? 'Yes' : 'Ja';
              let _allText = text + ': ' + value;
              splitAllText = doc.splitTextToSize(_allText, 190);
              doc.setTextColor('black');
              doc.setFontSize(12);
              doc.setFont('normal');
              doc.text(splitAllText, 20, count * 7 + margin + (y) * 7);
              if (splitAllText.length) {
                count = count + (Math.round(splitAllText.length * 0.8) - 1);
              }
              if (count * 7 + margin + (y) * 7 > 290) {
                doc.addPage('a4');
                count = 1;
                margin = 0;
              }
            }
          }
        } else {
          let individual = JSON.parse(this.array[i].data);
          if (individual.length) {
            for (let y = 0; y < individual.length; y++) {
              let text = individual[y].answer ? individual[y].question + ' : ' + individual[y].answer :
                individual[y].question + (this.lang === 'en' ? ' : Yes' : ' : Ja');
              splitAllText = doc.splitTextToSize(text, 190);
              doc.setTextColor('black');
              doc.setFontSize(12);
              doc.setFont('normal');
              doc.text(splitAllText, 20, count * 7 + margin + (y) * 7);
              if (splitAllText.length) {
                count = count + (Math.round(splitAllText.length * 0.8) - 1);
              }
              if (count * 7 + margin + (y) * 7 > 290) {
                doc.addPage('a4');
                count = 1;
                margin = 0;
              }
            }
          }
        }
      }
      if (count * 7 + margin > 290) {
        doc.addPage('a4');
        count = 1;
        margin = 0;
      }
      if (splitAllText.length) {
        count = count + splitAllText.length;
      } else {
        count++;
      }
    }

    // for (let i = 0; i < this.keys.length; i++) {
    //   if (this.userData[this.keys[i]] && this.userData[this.keys[i]] !== '') {
    //     if (this.keys[i] !== 'individual') {
    //       let text = this.tr.instant('guestModal.' + this.keys[i]);
    //       let value  = this.userData[this.keys[i]] === true ? this.lang === 'en' ? 'Yes' : 'Ja' : this.userData[this.keys[i]];
    //       doc.setTextColor('black');
    //       doc.setFontSize(12);
    //       doc.setFont('normal');
    //       doc.text(10 , count * 7 + margin , text + ': ' + value);
    //     } else {
    //       let individual =  this.userData[this.keys[i]];
    //       if (individual.length) {
    //         let text = this.tr.instant('guestModal.' + this.keys[i]);
    //         doc.setTextColor('black');
    //         doc.setFontSize(12);
    //         doc.setFont('normal');
    //         doc.text(10 , count * 7 + margin , text + ':');
    //         for (let y = 0; y < individual.length; y++) {
    //           let text = individual[y];
    //           let value  = this.lang === 'en' ? 'Yes' : 'Ja';
    //           doc.setTextColor('black');
    //           doc.setFontSize(12);
    //           doc.setFont('normal');
    //           doc.text(20 , count * 7 + margin + (y + 1) * 7 , text + ': ' + value);
    //           if (count * 7 + margin + (y + 1) * 7 > 270) {
    //             doc.addPage('a4');
    //             count = 1;
    //             margin = 0;
    //           }
    //         }
    //       }
    //     }
    //     if (count * 7 + margin > 270) {
    //       doc.addPage('a4');
    //       count = 1;
    //       margin = 0;
    //     }
    //     count++;
    //   }
    // }
    let filename = this.data.user.frontUserId ? this.data.user.frontUser.lastName + '_' + this.data.user.frontUser.firstName :
      this.data.user.lastName + '_' + this.data.user.firstName;
    doc.save(filename + '.pdf');
    this.spinner.hide();
  }

  onNoClick (): void {
    this.dialogRef.close();
  }

  editUserData() {
    const dialogRef = this.dialog.open(EditGuestData , {
      width: '900px',
      data: this.data
    });
    dialogRef.afterClosed().subscribe(res => {
      DialogOverview.dataWasChanged = false;
      if (res) {
        DialogOverview.dataWasChanged = true;
        this.dialogRef.close();
      }
    });
  }

}

@Component({
    selector: 'dialog-action',
    templateUrl: 'action-dialog.html',
    styleUrls: ['./participant.scss'],
    standalone: true,
  imports: [SharedModule]
})
export class DialogActionNew {

  constructor (public dialogRef: MatDialogRef<DialogActionNew> ,
               @Inject(MAT_DIALOG_DATA) public data) {
  }

  printList (): void {
    this.dialogRef.close('printList');
  }

  downloadCSV (): void {
    this.dialogRef.close('downloadCSV');
  }

  downloadXLSX (): void {
    this.dialogRef.close('downloadXLSX');
  }

  printCode (): void {
    this.dialogRef.close('printCode');
  }

  downloadCode (): void {
    this.dialogRef.close('downloadCode');
  }

  downloadAllPDF (): void {
    this.dialogRef.close('downloadAllPDF');
  }

}


export class FilesDataSource extends DataSource<any> {
  _filterChange = new BehaviorSubject('');
  _filteredDataChange = new BehaviorSubject('');

  get filteredData (): any {
    return this._filteredDataChange.value;
  }

  set filteredData (value: any) {
    this._filteredDataChange.next(value);
  }

  get filter (): string {
    return this._filterChange.value;
  }

  set filter (filter: string) {
    this._filterChange.next(filter);
  }

  constructor (private usersService ,
               private _paginator: MatPaginator ,
               private _sort: MatSort) {
    super();
    this.filteredData = this.usersService.users;
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect (): Observable<any[]> {
    const displayDataChanges = [
      this.usersService.onEventChanged ,
      this._paginator.page ,
      this._filterChange ,
      this._sort.sortChange
    ];

    return observableMerge(...displayDataChanges).pipe(map(() => {
      let data = this.usersService.users.slice();

      data = this.filterData(data);

      this.filteredData = [ ...data ];
      data = this.sortData(data);

      // Grab the page's slice of data.
      const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      return data.splice(startIndex , this._paginator.pageSize);
    }));
  }

  filterData (data) {
    if (!this.filter) {
      return data;
    }
    return FuseUtils.filterArrayByString(data , this.filter);
  }

  sortData (data): any[] {
    if (!this._sort.active || this._sort.direction === '') {
      return data;
    }

    return data.sort((a , b) => {
      let propertyA: number | string = '';
      let propertyB: number | string = '';
      let _a = '';
      let _b = '';
      switch (this._sort.active) {
        case 'name':
          _a = a.firstName ? a.lastName + a.firstName : a.frontUser.firstName ? a.frontUser.lastName + a.frontUser.firstName : '';
          _b = b.firstName ? b.lastName + b.firstName : b.frontUser.firstName ? b.frontUser.lastName + b.frontUser.firstName : '';
          [ propertyA , propertyB ] = [ _a , _b ];
          break;
        case 'organization':
          _a = a.organizationName ? a.organizationName : (a.frontUser && a.frontUser.organization) ? a.frontUser.organization.name : '';
          _b = b.organizationName ? b.organizationName : (b.frontUser && b.frontUser.organization) ? b.frontUser.organization.name : '';
          [ propertyA , propertyB ] = [ _a , _b ];
          break;
        case 'targetGroup':
          _a = (a.frontUser && a.frontUser.targetGroup) ? a.frontUser.targetGroup.ageMask : '';
          _b = (b.frontUser && b.frontUser.targetGroup) ? b.frontUser.targetGroup.ageMask : '';
          [ propertyA , propertyB ] = [ _a , _b ];
          break;
        case 'reward':
          _a = a.credits ? a.credits : '';
          _b = b.credits ? b.credits : '';
          [ propertyA , propertyB ] = [ _a , _b ];
          break;
        case 'createdAt':
          _a = a.createdAt ? a.createdAt : '';
          _b = b.createdAt ? b.createdAt : '';
          [ propertyA , propertyB ] = [ _a , _b ];
          break;
      }

      const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
      const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

      return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
    });
  }

  disconnect () {
  }
}
